
<template>
  <div class="item-box-content" style="min-height:632px">
    <div class="title-font-style">
      <span>退款结算</span>
    </div>
    <div style="margin:20px 30px 10px">
      <div class="title">合同概述：</div>
      <el-form class="details-line-height" style="margin-top:20px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同编号：">{{contractParams.contractCode}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称：">
              <span class="approval" @click="onCusName">{{contractParams.cusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户合同编号：">{{contractParams.customerContractCode}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同金额：">{{contractParams.contractTotal|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已收账款：">{{contractParams.accountsReceived|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应收帐款：">{{contractParams.accountsCollect|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已到期账款：">{{contractParams.accountsDue|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="未到期账款：">{{contractParams.accountsOutstanding|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同状态：">{{contractParams.signState|signStateFilters}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签订时间：">{{contractParams.signDate|dateFilter}}</el-form-item>
          </el-col>
          <el-col :span="12" style="margin-top:10px">
            <el-form-item label="退货商品价值：">{{params.returnPriceTotal|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12" style="margin-top:10px">
            <el-form-item label="客担罚没金额：">{{queryParams.customerCommitment|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="罚没比例：">{{params.forfeiturePenaltyTotal|perCentFilterL}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-steps
        :active="queryParams.state"
        style="width:60%;margin:0 auto 20px"
        class="mainStep"
        align-center
      >
        <el-step title="提交结算方案" icon="el-icon-success"></el-step>
        <el-step title="结算完成" icon="el-icon-success"></el-step>
      </el-steps>
      <div class="title" v-if="queryParams.state===2">结算方式：{{refundType===1?'原合同结算':'罚没金另行支付'}}</div>
      <div v-else>
        <div v-if="queryParams.customerCommitment">
          <span class="title">结算方式：</span>

          <el-radio-group
            class="dropdownright"
            v-model="refundType"
            size="mini"
            @change="changeRadio"
          >
            <el-radio-button :label="1">原合同结算</el-radio-button>
            <el-radio-button :label="2">罚没金另行支付</el-radio-button>
          </el-radio-group>
        </div>
        <div class="title" v-else>结算方式：原合同结算</div>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :span-method="objectSpanMethod"
        :header-cell-style="tableHeader"
      >
        <el-table-column>
          <template>结算说明</template>
        </el-table-column>
        <el-table-column label prop="accountType"></el-table-column>
        <el-table-column label="结算前">
          <template slot-scope="scope">{{scope.row.amountBeforeSettlement|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="结算后">
          <template slot-scope="scope">{{scope.row.amountAfterSettlement|priceFilterNum}}</template>
        </el-table-column>
      </el-table>
      <div style="margin-top:14px" v-show="refundType===2">
        客担罚没金：
        <span style="color:#D35E5E">{{queryParams.customerCommitment|priceFilterNum}}</span>
        元，另行进入客户待支付退货工单内，需销售划拨。
      </div>
      <el-button
        type="primary"
        style="margin-top:20px"
        v-show="queryParams.state===1"
        @click="onSubmit"
      >提交</el-button>
    </div>
  </div>
</template>

<script>
import { refundSettlement, refundSettlementCommit } from '@/api/sell/sellManage'
export default {
  data() {
    return {
      queryParams: {},
      params: {},
      contractParams: {}, // 合同详情
      refundType: 1,
      list: [],
      obj: {}
    }
  },
  methods: {
    getList(obj) {
      this.obj = obj
      refundSettlement(this.$route.query.id, obj.ocbId, obj.returnPriceStatus).then((res) => {
        if (res.data.code === 200) {
          this.queryParams = res.data.obj
          this.params = res.data.obj.orderContractSalereturnGoods
          this.list =
            res.data.obj.orderStatementOfSettlemenVoList ||
            res.data.obj.orderStatementOfSettlemenrefundTypeTwo
          this.contractParams = res.data.obj.orderContractBaseOtherPayVo
          if (res.data.obj.state === 2) {
            this.refundType = res.data.obj.refundType
          }
        }
      })
    },
    onSubmit() {
      this.queryParams.refundType = this.refundType
      // const res = {
      //   data: {
      //     code: 700021,
      //     msg: '账户余额不足'
      //   }
      // }
      refundSettlementCommit(this.queryParams).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('提交成功')
          this.obj.returnPriceStatus = 2
          this.getList(this.obj)
          this.$emit('onSuccess')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeRadio(val) {
      this.list =
        val === 1
          ? this.queryParams.orderStatementOfSettlemenVoList
          : this.queryParams.orderStatementOfSettlemenrefundTypeTwo
    },
    onCusName() {
      this.$router.push({
        name: 'customer/details',
        query: { id: this.contractParams.cusId }
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 4,
            colspan: 1
          }
        } else {
          return {
            rowspan: 2,
            colspan: 0
          }
        }
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  line-height: 24px;
}
.dropdownright {
  margin-right: 15px;
  line-height: 28px;
  vertical-align: middle;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #276cff;
  border-color: #276cff;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
  color: #fff;
}
/deep/.el-radio-button__inner:hover {
  color: #276cff;
}
</style>
